module.exports = __webpack_public_path__ + "static/media/paper-plane-solid.adb6025b.svg";